"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class BounceEmail extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'bounceEmail';
        this._email = initParams.email;
    }
    set email(value) {
        console.error('Do not set objects this way');
    }
    get email() {
        return this._email;
    }
    delete() {
        return this.dataService.deleteBounceEmail(this.id, this);
    }
}
exports.default = BounceEmail;
//# sourceMappingURL=bounceEmail.js.map